// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FLmJ","badges":"styles_badges__2B2bQ"};